module.exports = __webpack_public_path__ + "static/media/EN.db68882c.svg";